import React, { useState, useEffect } from "react";
import axios from "axios";
import BuyerDetails from "./BuyerDetails";
import BuyerManagementDetails from "./BuyerManagementDetails";
import BasicDetails from "./BasicDetails";
import GeoDetails from "./GeoDetails";
import Executives from "./Executives";
import OtherBusinessDetails from "./OtherBusinessDetails";
import FilesAttachments from "./FilesAttachments";
import Security from "./Security";

const FormSettings = () => {
  const [dynamicFields, setDynamicFields] = useState([]);

  // Fetch dynamic fields from API
  useEffect(() => {
    const fetchFields = async () => {
      try {
        // Parse the URLs from environment variable
        const apiUrls = process.env.REACT_APP_API_URLS;

        // const apiUrl = "https://zmmbetest.etpl.cloud"; // Fallback to localhost if no URL is found

        // Make the API request using the dynamic URL
        const response = await axios.get(
          // `${apiUrls}/addbuyer/get-buyer-fields/`
          `${apiUrls}/buyer_settings/custom-fields/`
        );

        // Ensure the response is an array before setting it
        // console.log(response.data);
        if (Array.isArray(response.data)) {
          setDynamicFields(response.data); // Store API response directly
        } else {
          console.error("API response is not an array:", response.data);
        }
      } catch (error) {
        console.error("Error fetching buyer fields:", error);
      }
    };

    fetchFields();
  }, []);
  // console.log("dynamicFields", dynamicFields);

  // Function to update dynamic fields for a specific section
  const updateDynamicFields = (section, updatedFields) => {
    setDynamicFields((prevFields) => ({
      ...prevFields,
      [section]: updatedFields,
    }));
  };

  return (
    <div className="border-2 border-gray-200 rounded-2xl mx-10 p-5">
      <div className="border-b flex justify-between items-center pb-2">
        <div className='font-semibold text-gray-600 text-xl'>
          Form Settings
        </div>
        <div>
          <button className='text-white bg-gray-800 px-3 py-1 text-md font-semibold rounded-lg'>Update</button>
        </div>
      </div>

      <div className="flex flex-col">
        <BuyerDetails
          // dynamicFields={dynamicFields["Buyer Details"] || []}
          hidden={true}
          dynamicFields={dynamicFields}
          require={false}
          setDynamicFields={(updatedFields) =>
            updateDynamicFields("Buyer Details", updatedFields)
          }
        />
        <BuyerManagementDetails
          require={false}
          dynamicFields={dynamicFields}
          setDynamicFields={(updatedFields) =>
            updateDynamicFields("Buyer Management Details", updatedFields)
          }
        />
        <BasicDetails
          require={false}
          dynamicFields={dynamicFields}
          setDynamicFields={(updatedFields) =>
            updateDynamicFields("Basic Details", updatedFields)
          }
        />
        <GeoDetails
          require={false}
          // dynamicFields={dynamicFields["Geo Details"] || []}
          dynamicFields={dynamicFields}
          setDynamicFields={(updatedFields) =>
            updateDynamicFields("Geo Details", updatedFields)
          }
        />
        <Executives
          require={false}
          // dynamicFields={dynamicFields["executive"] || []}
          dynamicFields={dynamicFields}
          setDynamicFields={(updatedFields) =>
            updateDynamicFields("executive", updatedFields)
          }
        />
        <OtherBusinessDetails
          require={false}
          // dynamicFields={dynamicFields["Other Business Details"] || []}
          dynamicFields={dynamicFields}
          setDynamicFields={(updatedFields) =>
            updateDynamicFields("Other Business Details", updatedFields)
          }
        />
        <FilesAttachments
          require={false}
          dynamicFields={dynamicFields["Files Attachments"] || []}
          setDynamicFields={(updatedFields) =>
            updateDynamicFields("Files Attachments", updatedFields)
          }
        />
        <Security
          require={false}
          // dynamicFields={dynamicFields["Security"] || []}
          dynamicFields={dynamicFields}
          setDynamicFields={(updatedFields) =>
            updateDynamicFields("Security", updatedFields)
          }
        />
      </div>
    </div>
  );
};

export default FormSettings;
